import CartDetails from 'components/CartDetails';
import { H4 } from 'components/Text';
import { CustomerTicket } from 'interfaces/booking';
import { FlightDetails } from 'interfaces/flightDetails';
import { useTranslation } from 'next-i18next/pages';

interface ICartFlightsProps {
  flightDetails: FlightDetails;
  backgroundColor?: string;
  status?: string;
  ticket?: CustomerTicket;
  orderId?: string;
  isCart?: boolean;
  isCartPackagesModal?: boolean;
}

const CartFlights: React.FC<ICartFlightsProps> = ({
  flightDetails,
  backgroundColor,
  status,
  ticket,
  isCart,
  isCartPackagesModal,
}) => {
  const { t } = useTranslation();
  const cartFlightDetails = flightDetails?.result?.combinations;
  if (!flightDetails || cartFlightDetails.length === 0) return null;

  return (
    <div
      className={`flex ${
        isCart ? 'flex-col' : 'md:flex-row flex-col md:space-x-4 items-start'
      }`}>
      <div className="flex-1">
        <H4 className="md:hidden">{t('Outbound')}</H4>
        <CartDetails
          flightDetails={flightDetails}
          content={cartFlightDetails[0].firstLeg}
          customBg={backgroundColor}
          status={status}
          ticket={ticket?.response?.tickets?.firstLeg}
          pnr={ticket?.response?.pnr?.firstLeg}
          isFirstLeg
          isCart={isCart}
          isCartPackagesModal={isCartPackagesModal}
        />
      </div>
      <div className="flex-1 mb-12 md:mb-0">
        {cartFlightDetails[0].returnLeg && (
          <>
            <H4 className="md:hidden">{t('Return')}</H4>
            <CartDetails
              flightDetails={flightDetails}
              content={cartFlightDetails[0].returnLeg}
              customBg={backgroundColor}
              status={status}
              ticket={ticket?.response?.tickets?.returnLeg}
              pnr={ticket?.response?.pnr?.returnLeg}
              isCart={isCart}
              isFirstLeg={false}
              isCartPackagesModal={isCartPackagesModal}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CartFlights;
